import { enabledAuthProviders, type SocialProvider } from '@words-happen/ui-components';

/**
 * This build's enabled providers, from VITE_AUTH_PROVIDERS (`enabledAuthProviders` in @words-happen/ui-components):
 * the same setting and parsing as the identity app, so /welcome offers what its /sign-in does.
 */
export const ENABLED_AUTH_PROVIDERS: readonly SocialProvider[] = enabledAuthProviders(
  import.meta.env.VITE_AUTH_PROVIDERS,
);
